export default {
  fonts: {
    xs: '10px',
    sm: '12px',
    smd: '14px',
    md: '16px',
    lg: '1.2em',
    xl: '1.4em',
    xxl: '2em',
  },
  misc: {
    borderRadius: 2,
    boxShadow: '0 1px 6px 0 rgba(32, 33, 36, .2)',
  },
};
